import { HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

interface ExponentialBackoffPolicy {
    /* Set the maximum number of retries that will be performed */
    maxRetryAttempts?: number;

    /* Set the ms duration factor that will be used to calculate next exponential delay timer.
     * By default is set to 100ms, which means that the first retry will occur 10.000ms ((1*100ms)^2) after failing for the first time
     * PS: 10.000ms is 10 seconds, and will increase exponentially as shown
     */
    scalingDuration?: number;

    /* Set the HTTP Status codes that shouldn't be retried. By default, we should set 500 (internal error), 404 (not found) and
     * 403 (forbidden) to improve performance, since these codes will most likely fail all retries attempts
     */
    excludedStatusCodes?: number[];
}

export const retryExponentialBackoffPolicy = ({
    maxRetryAttempts = 0,
    scalingDuration = 100,
    excludedStatusCodes = [],
}: ExponentialBackoffPolicy = {}) => {
    return <T>(attempts: Observable<T>) => {
        return attempts.pipe(
            mergeMap((error, i) => {
                const retryAttempt = i + 1;

                if (
                    retryAttempt > maxRetryAttempts ||
                    maxRetryAttempts === 0 ||
                    excludedStatusCodes.find((e) => error instanceof HttpErrorResponse && e === error.status)
                ) {
                    return throwError(error);
                }

                const exponentialDelay = Math.pow(retryAttempt * scalingDuration, 2);

                console.log(`Attempt ${retryAttempt}: retrying in ${exponentialDelay}ms`);

                return timer(exponentialDelay);
            })
        );
    };
};
